import React, { FC } from 'react'

export type Props = {
  text: string
}

export const Header: FC<Props> = ({ text }) => {
  return <div className="CS-header">{text}</div>
}
